import api from './api';

export const addressService = {
  list: async () => {
    const response = await api.get('/user/addresses');
    return response.data?.data?.addresses || [];
  },
  create: async (payload) => {
    const response = await api.post('/user/addresses', payload);
    return response.data?.data?.address;
  },
  update: async (id, payload) => {
    const response = await api.put(`/user/addresses/${id}`, payload);
    return response.data?.data?.address;
  },
  remove: async (id) => {
    const response = await api.delete(`/user/addresses/${id}`);
    return response.data;
  },
  setDefault: async (id) => {
    const response = await api.put(`/user/addresses/${id}/default`);
    return response.data?.data?.address;
  },
};
